import PropTypes from 'prop-types';
import React from 'react';

const Go = ({ className }) => (
  <svg
    className={className}
    width="1731"
    height="857"
    viewBox="0 0 1731 857"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.12" cx="1558" cy="124" r="124" fill="url(#paint0_linear_1112_12254)" />
    <circle opacity="0.12" cx="1558" cy="124" r="104" fill="url(#paint1_linear_1112_12254)" />
    <mask
      id="mask0_1112_12254"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="1454"
      y="20"
      width="208"
      height="208"
    >
      <circle cx="1558" cy="124" r="104" fill="#181A1B" />
    </mask>
    <g mask="url(#mask0_1112_12254)">
      <g opacity="0.8">
        <path
          d="M1086 199.27C1089.57 196.72 1093.14 194.39 1096.71 192.15C1100.61 189.72 1104.5 187.39 1108.39 185.15C1112.28 182.91 1116.18 180.59 1120.08 178.34L1131.76 171.56L1143.44 164.81C1147.34 162.57 1151.23 160.323 1155.12 158.07L1166.8 151.32L1178.5 144.56C1182.39 142.313 1186.28 140.067 1190.18 137.82L1201.86 131.07L1213.5 124.32C1217.39 122.073 1221.28 119.827 1225.18 117.58L1236.85 110.83L1248.54 104.08L1260.22 97.3398L1271.93 90.5598L1283.62 83.8098C1287.51 81.5698 1291.4 79.3098 1295.31 77.0698C1299.22 74.8298 1303.09 72.5698 1306.99 70.3198L1318.68 63.5698L1330.36 56.8198L1342.05 50.0698L1353.73 43.3298L1365.42 36.5798L1377.1 29.8398L1388.78 23.0998L1400.5 16.3998C1404.39 14.1398 1408.29 11.8898 1412.18 9.64984L1423.86 2.89984L1435.5 -3.83015L1447.19 -10.5702C1451.08 -12.8102 1454.97 -15.0368 1458.86 -17.2502C1462.75 -19.4502 1466.65 -21.6302 1470.54 -23.7002C1474.43 -25.7702 1478.33 -27.7002 1482.23 -29.4002C1486.01 -31.054 1489.91 -32.3919 1493.91 -33.4002C1497.73 -34.3567 1501.66 -34.8404 1505.6 -34.8402C1509.52 -34.7525 1513.42 -34.3512 1517.27 -33.6402C1521.17 -33.0002 1525.07 -32.2502 1528.96 -31.9702C1532.88 -31.6055 1536.84 -31.9441 1540.64 -32.9702C1544.89 -34.2659 1548.86 -36.3525 1552.33 -39.1202C1556.61 -42.5558 1560.52 -46.4229 1564 -50.6602C1565.02 -51.8602 1566.02 -53.0802 1567 -54.3202C1567.98 -55.5602 1568.96 -56.8068 1569.94 -58.0602C1571.86 -60.5602 1573.82 -63.1602 1575.72 -65.6802C1579.59 -70.8302 1583.57 -76.0602 1587.66 -80.9302C1591.41 -85.4276 1595.39 -89.7204 1599.6 -93.7902C1601.33 -95.4502 1603.04 -96.9802 1604.82 -98.4702C1606.6 -99.9602 1608.36 -101.33 1610.16 -102.69C1612.16 -104.18 1614.16 -105.6 1616.16 -106.99C1618.16 -108.38 1620.16 -109.72 1622.16 -110.99C1624.96 -112.82 1627.8 -114.61 1655.47 -129.91"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1086 265.18C1088.92 262.12 1091.83 258.68 1094.75 255.04C1098.65 250.18 1102.53 244.97 1106.43 239.98C1110.33 234.99 1114.23 230.24 1118.12 225.98C1121.78 221.909 1125.68 218.056 1129.79 214.44C1133.53 211.189 1137.44 208.142 1141.5 205.31C1145.39 202.58 1149.28 200.08 1153.18 197.68C1157.08 195.28 1160.96 192.98 1164.86 190.68C1168.76 188.38 1172.65 186.14 1176.55 183.88L1188.22 177.13L1199.91 170.39L1211.59 163.64L1223.27 156.89L1234.95 150.15L1246.63 143.41C1250.52 141.164 1254.41 138.914 1258.31 136.66L1269.99 129.92L1281.68 123.18L1293.36 116.43L1305.03 109.69L1316.72 102.94L1328.41 96.2003L1340.1 89.4503L1351.78 82.7003L1363.5 75.9603L1375.19 69.2103L1386.87 62.4703L1398.5 55.7303L1410.17 48.9803L1421.85 42.2303C1425.75 39.9836 1429.64 37.737 1433.53 35.4903L1445.21 28.7603L1456.89 22.0203C1460.79 19.7703 1464.67 17.5303 1468.57 15.3103C1472.47 13.0903 1476.36 10.8803 1480.25 8.76031C1484.14 6.64032 1488.03 4.58031 1491.92 2.76031C1495.7 0.944838 1499.61 -0.602302 1503.61 -1.86967C1507.41 -3.05446 1511.32 -3.80264 1515.29 -4.09969C1519.19 -4.30936 1523.1 -4.13855 1526.97 -3.58969C1530.86 -3.07969 1534.76 -2.32969 1538.66 -1.84969C1542.53 -1.27986 1546.45 -1.24958 1550.33 -1.75969C1554.48 -2.43422 1558.45 -3.9155 1562.03 -6.11969C1566.32 -8.83319 1570.25 -12.0864 1573.71 -15.7997C1577.84 -20.2329 1581.74 -24.8757 1585.39 -29.7097C1589.28 -34.7097 1593.18 -40.0197 1597.08 -44.9897C1600.82 -49.7697 1604.76 -54.5197 1608.8 -58.7997C1610.73 -60.8397 1612.69 -62.7864 1614.68 -64.6397C1616.67 -66.493 1618.69 -68.253 1620.74 -69.9197C1622.74 -71.5097 1624.74 -73.0397 1626.68 -74.4897C1628.62 -75.9397 1630.68 -77.3397 1632.68 -78.6697C1634.45 -79.8597 1636.18 -80.9697 1637.96 -82.0897C1639.74 -83.2097 1641.47 -84.2497 1643.25 -85.3197C1649.97 -89.3197 1657.17 -93.5797 1722.46 -129.93"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1086 312.559L1090.5 310.019C1094.5 307.759 1098.5 305.519 1102.44 303.409C1104.4 302.355 1106.36 301.339 1108.31 300.359C1110.31 299.359 1112.23 298.469 1114.17 297.609C1117.95 295.902 1121.86 294.494 1125.86 293.399C1129.67 292.379 1133.59 291.809 1137.54 291.699C1141.45 291.67 1145.36 291.96 1149.22 292.569C1153.12 293.119 1157.02 293.809 1160.91 294.109C1164.81 294.496 1168.76 294.267 1172.59 293.429C1176.77 292.399 1180.73 290.609 1184.27 288.149C1188.53 285.145 1192.45 281.677 1195.95 277.809C1199.85 273.639 1203.74 268.809 1207.63 263.879C1211.52 258.949 1215.43 253.879 1219.32 249.049C1223.21 244.219 1227.1 239.759 1231 235.729C1234.68 231.915 1238.58 228.318 1242.68 224.959C1246.58 221.759 1250.47 218.959 1254.36 216.279C1258.25 213.599 1262.15 211.199 1266.04 208.829C1269.93 206.459 1273.83 204.169 1277.73 201.899L1289.41 195.109L1301.09 188.359L1312.77 181.619L1324.5 174.879C1328.39 172.632 1332.28 170.385 1336.18 168.139L1347.86 161.389L1359.5 154.649L1371.19 147.899L1382.87 141.149L1394.55 134.409L1406.24 127.659L1417.93 120.909L1429.61 114.169L1441.31 107.409L1452.99 100.669L1464.67 93.9186L1476.35 87.1786L1488.04 80.4486C1491.93 78.2019 1495.82 75.9753 1499.71 73.7686C1503.6 71.5586 1507.5 69.3786 1511.39 67.3086C1515.28 65.2386 1519.18 63.3086 1523.07 61.6086C1526.84 59.9363 1530.74 58.5979 1534.74 57.6086C1538.57 56.7021 1542.5 56.2755 1546.43 56.3386C1550.35 56.4885 1554.25 56.9365 1558.1 57.6786C1561.96 58.4381 1565.87 58.9922 1569.79 59.3386C1573.73 59.6483 1577.7 59.2383 1581.5 58.1286C1585.75 56.7494 1589.7 54.5965 1593.17 51.7786C1597.45 48.2888 1601.37 44.3829 1604.87 40.1186C1608.76 35.5086 1612.65 30.3186 1616.55 25.1686C1620.45 20.0186 1624.34 14.8886 1628.23 10.1686C1631.88 5.75266 1635.77 1.54283 1639.88 -2.44141C1643.57 -5.96139 1647.48 -9.2541 1651.57 -12.3014C1655.46 -15.2114 1659.36 -17.8114 1663.25 -20.3014C1665.2 -21.5414 1667.16 -22.7514 1669.12 -23.9314C1671.12 -25.1214 1673.02 -26.2814 1674.98 -27.4414C1678.98 -29.7947 1682.96 -32.1281 1686.92 -34.4414C1690.88 -36.7547 1694.86 -39.0547 1698.85 -41.3414L1709.41 -47.4514L1771.94 -83.4414"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1086 350.751C1091.04 347.851 1096.07 344.944 1101.1 342.031L1111.67 335.931L1123.6 329.051L1135.5 322.171C1139.41 319.924 1143.32 317.694 1147.23 315.481C1151.13 313.271 1155.02 311.111 1158.91 309.081C1162.8 307.051 1166.71 305.131 1170.6 303.511C1174.38 301.902 1178.29 300.611 1182.28 299.651C1186.11 298.755 1190.03 298.289 1193.96 298.261C1197.87 298.3 1201.77 298.604 1205.64 299.171C1209.54 299.671 1213.44 300.251 1217.33 300.441C1221.25 300.692 1225.19 300.331 1229 299.371C1233.19 298.193 1237.15 296.291 1240.69 293.751C1244.95 290.668 1248.87 287.134 1252.37 283.211C1256.27 278.971 1260.15 274.051 1264.05 269.021C1267.95 263.991 1271.84 258.841 1275.74 254.021C1279.64 249.201 1283.52 244.681 1287.41 240.701C1291.08 236.939 1294.99 233.408 1299.1 230.131C1302.99 227.021 1306.88 224.271 1310.78 221.701C1314.68 219.131 1318.56 216.701 1322.46 214.391C1326.36 212.081 1330.25 209.771 1334.14 207.511C1338.03 205.251 1341.92 202.991 1345.82 200.741C1349.72 198.491 1353.6 196.241 1357.5 193.991L1369.18 187.251L1380.86 180.501L1392.55 173.751L1404.23 167.011L1415.91 160.261L1427.64 153.561L1439.32 146.811L1451.01 140.061L1462.7 133.311L1474.39 126.561L1486.07 119.811L1497.76 113.071C1501.66 110.824 1505.55 108.584 1509.43 106.351C1513.34 104.121 1517.23 101.901 1521.12 99.7507C1525.01 97.6007 1528.91 95.4907 1532.79 93.5807C1536.58 91.6746 1540.49 90.0177 1544.5 88.6207C1548.28 87.3102 1552.2 86.4672 1556.18 86.1107C1560.08 85.8345 1564 85.9989 1567.86 86.6007C1571.75 87.1507 1575.65 87.9807 1579.54 88.6007C1583.39 89.301 1587.32 89.4592 1591.22 89.0707C1595.36 88.5146 1599.34 87.0939 1602.9 84.9007C1607.22 82.1835 1611.15 78.8936 1614.58 75.1207C1618.72 70.6171 1622.62 65.9006 1626.26 60.9907C1630.15 55.8807 1634.05 50.5807 1637.95 45.6207C1641.85 40.6607 1645.73 36.0407 1649.63 31.9507C1653.29 28.104 1657.19 24.4998 1661.32 21.1607C1665.21 17.9907 1669.1 15.2207 1673 12.6307C1676.9 10.0407 1680.78 7.6307 1684.68 5.3007C1688.58 2.97071 1692.47 0.6807 1696.37 -1.5793C1700.27 -3.8393 1704.18 -6.1193 1708.09 -8.3793L1720.03 -15.2793L1731.96 -22.1593L1742.5 -28.2793L1771.95 -45.2793"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1086 284.729C1088.26 284.729 1090.52 284.939 1092.79 285.189C1096.68 285.629 1100.58 286.319 1104.47 286.749C1108.35 287.264 1112.27 287.264 1116.15 286.749C1120.29 286.088 1124.26 284.628 1127.84 282.449C1132.12 279.776 1136.04 276.567 1139.5 272.899C1143.64 268.558 1147.54 264.002 1151.2 259.249C1155.1 254.249 1158.98 249.059 1162.88 244.149C1166.78 239.239 1170.66 234.659 1174.56 230.559C1178.24 226.673 1182.14 223 1186.24 219.559C1190.14 216.309 1194.03 213.429 1197.92 210.769C1201.81 208.109 1205.71 205.639 1209.61 203.269C1213.51 200.899 1217.39 198.599 1221.29 196.319C1225.19 194.039 1229.07 191.789 1232.97 189.539L1244.65 182.779L1256.33 176.039L1268.02 169.289L1279.69 162.559L1291.38 155.809L1303.06 149.069L1314.74 142.329L1326.41 135.559L1338.1 128.819L1349.79 122.069L1361.5 115.299L1373.16 108.559L1384.85 101.809L1396.5 95.0593L1408.19 88.3193L1419.9 81.5593L1431.59 74.8093L1443.26 68.0693L1454.95 61.3293L1466.62 54.5593L1478.3 47.8393C1482.2 45.5993 1486.1 43.386 1489.99 41.1993C1493.88 39.0293 1497.77 36.9093 1501.66 34.9593C1505.45 33.017 1509.36 31.2942 1513.35 29.7993C1517.12 28.397 1521.03 27.3915 1525.01 26.7993C1528.89 26.2849 1532.81 26.2044 1536.7 26.5593C1540.59 26.8893 1544.49 27.5593 1548.39 28.2293C1552.24 28.9595 1556.15 29.2945 1560.07 29.2293C1564.12 29.0571 1568.09 28.0637 1571.75 26.3093C1576.04 24.1594 1579.98 21.3673 1583.43 18.0293C1587.63 13.9779 1591.54 9.63363 1595.12 5.0293C1599.02 0.159297 1602.9 -5.11071 1606.8 -10.1707C1610.7 -15.2307 1614.59 -20.0407 1618.5 -24.4407C1622.17 -28.5624 1626.07 -32.4689 1630.19 -36.1407C1633.93 -39.4238 1637.84 -42.5049 1641.91 -45.3707C1643.91 -46.7807 1645.91 -48.1207 1647.91 -49.3707C1649.91 -50.6207 1651.91 -51.9207 1653.91 -53.1507C1657.85 -55.5807 1661.91 -57.9807 1665.84 -60.3007C1669.31 -62.394 1672.8 -64.4407 1676.33 -66.4407C1708.2 -84.9007 1740.07 -103.151 1771.94 -121.971"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1127.5 556L1299.6 456.63L1310.16 450.56L1322.1 443.67L1334.04 436.78L1345.77 430L1357.5 423.24L1369.18 416.49L1380.86 409.75L1392.5 403L1404.17 396.26L1415.87 389.56L1427.5 382.77L1439.19 376.02L1450.88 369.28L1462.59 362.56L1474.28 355.85C1478.17 353.62 1482.06 351.41 1485.95 349.26C1489.84 347.11 1493.74 345.01 1497.64 343.06C1501.54 341.11 1505.43 339.32 1509.32 337.82C1513.11 336.34 1517.02 335.167 1521 334.31C1524.85 333.517 1528.75 333.072 1532.68 332.98C1536.58 332.89 1540.46 333.12 1544.36 333.35C1548.26 333.58 1552.14 333.79 1556.04 333.68C1559.98 333.604 1563.89 333.101 1567.72 332.18C1571.78 331.161 1575.7 329.66 1579.4 327.71C1583.5 325.542 1587.42 323.026 1591.09 320.19C1594.98 317.24 1598.87 313.88 1602.77 310.4C1606.67 306.92 1610.55 303.32 1614.45 299.85C1618.35 296.38 1622.24 293.04 1626.14 290.03C1629.85 287.11 1633.76 284.438 1637.82 282.03C1641.56 279.853 1645.48 277.981 1649.52 276.43C1653.34 275.003 1657.24 273.804 1661.2 272.84C1665.11 271.84 1669 271.06 1672.89 270.1C1676.87 269.168 1680.77 267.941 1684.57 266.43C1688.69 264.724 1692.61 262.564 1696.26 259.99C1700.45 256.982 1704.35 253.601 1707.93 249.89C1711.84 245.89 1715.73 241.37 1719.62 236.57C1723.51 231.77 1727.4 226.71 1731.29 221.9C1735.18 217.09 1739.08 212.5 1742.97 208.36C1750 200.825 1757.83 194.076 1766.32 188.23C1768.2 186.93 1770.07 185.69 1771.94 184.49"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1086 541.76L1266.5 437.56L1277.06 431.46L1289.01 424.56C1293.01 422.26 1297.01 419.96 1301.01 417.66L1312.73 410.89L1324.42 404.15L1336.11 397.4L1347.79 390.66L1359.47 383.91L1371.15 377.17L1382.84 370.42L1394.5 363.67L1406.17 356.93C1410.07 354.683 1413.97 352.447 1417.86 350.22C1421.75 347.99 1425.65 345.78 1429.54 343.63C1433.43 341.48 1437.33 339.39 1441.23 337.46C1445.02 335.541 1448.92 333.831 1452.9 332.34C1456.68 330.913 1460.59 329.851 1464.58 329.17C1468.44 328.543 1472.36 328.329 1476.27 328.53C1480.16 328.72 1484.05 329.27 1487.94 329.75C1491.81 330.295 1495.72 330.532 1499.63 330.46C1503.62 330.344 1507.57 329.566 1511.31 328.16C1515.52 326.499 1519.46 324.213 1522.99 321.38C1527.17 318.011 1531.08 314.312 1534.67 310.32C1538.55 306.12 1542.45 301.5 1546.35 296.84C1550.25 292.18 1554.13 287.49 1558.03 283.05C1561.93 278.61 1565.81 274.43 1569.71 270.61C1573.61 266.79 1577.5 263.37 1581.4 260.21C1585.3 257.05 1589.18 254.21 1593.08 251.55C1596.98 248.89 1600.88 246.45 1604.77 244.23C1608.66 242.01 1612.57 239.98 1616.46 238.23C1620.25 236.486 1624.15 235.016 1628.15 233.83C1631.96 232.706 1635.88 231.983 1639.84 231.67C1643.73 231.44 1647.64 231.52 1651.52 231.91C1655.42 232.25 1659.32 232.75 1663.2 232.98C1667.1 233.302 1671.03 233.107 1674.88 232.4C1679.03 231.499 1682.97 229.831 1686.5 227.48C1690.78 224.588 1694.7 221.194 1698.18 217.37C1702.07 213.21 1705.97 208.37 1709.86 203.37C1713.75 198.37 1717.65 193.1 1721.54 188.18C1725.43 183.26 1729.32 178.66 1733.21 174.59C1736.88 170.756 1740.78 167.156 1744.9 163.81C1748.79 160.66 1752.68 157.89 1756.57 155.31C1760.46 152.73 1764.36 150.31 1768.26 148.01L1771.91 145.84"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1086 503.559L1233.44 418.439L1244 412.339L1255.93 405.449L1267.87 398.559L1279.6 391.789C1283.5 389.529 1287.4 387.289 1291.29 385.029L1302.98 378.289L1314.65 371.559L1326.34 364.809L1338.01 358.069L1349.7 351.329C1353.6 349.082 1357.49 346.845 1361.38 344.619C1365.27 342.399 1369.17 340.189 1373.07 338.039C1376.97 335.889 1380.85 333.799 1384.74 331.889C1388.54 329.993 1392.44 328.308 1396.42 326.839C1400.21 325.438 1404.12 324.393 1408.11 323.719C1411.97 323.119 1415.89 322.911 1419.79 323.099C1423.68 323.259 1427.58 323.759 1431.47 324.199C1435.34 324.726 1439.24 324.96 1443.15 324.899C1447.14 324.793 1451.09 324.016 1454.83 322.599C1459.07 320.882 1463.01 318.506 1466.5 315.559C1470.72 312 1474.63 308.082 1478.17 303.849C1482.07 299.339 1485.96 294.329 1489.86 289.309C1493.76 284.289 1497.64 279.309 1501.53 274.699C1505.21 270.364 1509.12 266.218 1513.22 262.279C1516.93 258.735 1520.83 255.397 1524.9 252.279C1528.78 249.279 1532.68 246.619 1536.58 244.089C1540.48 241.559 1544.36 239.169 1548.27 236.829C1552.18 234.489 1556.05 232.209 1559.95 229.939C1563.85 227.669 1567.74 225.409 1571.64 223.169C1575.54 220.929 1579.43 218.689 1583.33 216.489C1587.23 214.289 1591.12 212.129 1595.02 210.079C1598.92 208.029 1602.81 206.079 1606.7 204.419C1610.48 202.793 1614.39 201.501 1618.4 200.559C1622.23 199.652 1626.16 199.229 1630.09 199.299C1634.01 199.426 1637.91 199.847 1641.77 200.559C1645.64 201.343 1649.56 201.908 1653.5 202.249C1657.44 202.557 1661.41 202.113 1665.18 200.939C1669.45 199.451 1673.41 197.179 1676.85 194.239C1681.12 190.588 1685.02 186.529 1688.5 182.119C1692.39 177.339 1696.28 171.959 1700.17 166.689C1704.06 161.419 1707.96 156.259 1711.85 151.639C1715.47 147.305 1719.36 143.204 1723.5 139.359C1727.19 135.983 1731.1 132.84 1735.18 129.949C1739.08 127.169 1742.97 124.679 1746.87 122.279C1750.77 119.879 1754.65 117.589 1758.55 115.279L1770.25 108.559L1771.94 107.559"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1086 465.361L1200.35 399.361L1210.91 393.271L1222.85 386.381L1234.79 379.481L1246.5 372.681L1258.18 365.941L1269.87 359.191L1281.55 352.441L1293.24 345.701C1297.13 343.461 1301.02 341.227 1304.91 339.001C1308.81 336.771 1312.71 334.561 1316.6 332.421C1320.49 330.281 1324.38 328.201 1328.27 326.321C1332.07 324.448 1335.97 322.799 1339.96 321.381C1343.75 320.035 1347.67 319.071 1351.65 318.501C1355.52 317.993 1359.43 317.869 1363.32 318.131C1367.22 318.351 1371.11 318.871 1375.01 319.321C1378.88 319.841 1382.78 320.029 1386.68 319.881C1390.7 319.647 1394.65 318.734 1398.37 317.181C1402.6 315.333 1406.54 312.87 1410.05 309.871C1414.25 306.266 1418.15 302.338 1421.73 298.121C1425.62 293.631 1429.52 288.701 1433.41 283.731C1437.3 278.761 1441.19 273.801 1445.09 269.201C1448.99 264.601 1452.87 260.421 1456.77 256.661C1460.49 253.094 1464.4 249.739 1468.5 246.611C1472.39 243.611 1476.28 240.961 1480.18 238.431C1484.08 235.901 1487.97 233.531 1491.87 231.211C1495.77 228.891 1499.65 226.601 1503.55 224.331C1507.45 222.061 1511.33 219.821 1515.23 217.561L1526.92 210.811L1538.6 204.061L1550.29 197.321L1561.95 190.561C1565.86 188.321 1569.76 186.101 1573.64 183.941C1577.52 181.781 1581.43 179.661 1585.32 177.741C1589.1 175.817 1593.01 174.146 1597.01 172.741C1604.49 170.061 1612.55 169.395 1620.37 170.811C1624.27 171.451 1628.16 172.471 1632.04 173.151C1635.88 173.927 1639.83 174.092 1643.72 173.641C1647.91 173.003 1651.9 171.438 1655.4 169.061C1659.74 166.039 1663.67 162.462 1667.08 158.421C1670.97 154.001 1674.86 148.831 1678.76 143.521C1682.66 138.211 1686.54 132.761 1690.44 127.841C1694.06 123.217 1697.96 118.822 1702.12 114.681C1705.79 111.057 1709.69 107.676 1713.8 104.561C1717.7 101.611 1721.59 99.0008 1725.48 96.5608C1729.37 94.1208 1733.27 91.7508 1737.17 89.4508C1741.07 87.1508 1744.95 84.9008 1748.85 82.6408C1752.75 80.3808 1756.65 78.1408 1760.54 75.8808L1771.94 69.3008"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1086 427.15L1167.27 380.23L1177.83 374.14L1189.76 367.25L1201.71 360.35L1213.43 353.56L1225.12 346.81L1236.8 340.07L1248.5 333.37C1252.4 331.14 1256.3 328.91 1260.19 326.74C1264.08 324.57 1267.98 322.45 1271.87 320.5C1275.64 318.557 1279.53 316.835 1283.5 315.34C1287.28 313.923 1291.19 312.894 1295.18 312.27C1299.05 311.711 1302.96 311.58 1306.86 311.88C1310.76 312.15 1314.66 312.8 1318.55 313.36C1322.41 314.012 1326.32 314.303 1330.23 314.23C1334.27 314.074 1338.24 313.168 1341.94 311.56C1346.2 309.637 1350.13 307.078 1353.62 303.97C1357.82 300.247 1361.72 296.209 1365.3 291.89C1369.2 287.32 1373.09 282.31 1376.99 277.35C1380.89 272.39 1384.77 267.47 1388.66 262.98C1392.34 258.703 1396.24 254.621 1400.35 250.75C1404.06 247.262 1407.96 243.978 1412.03 240.91C1415.91 237.97 1419.81 235.32 1423.71 232.81C1427.61 230.3 1431.49 227.93 1435.39 225.6C1439.29 223.27 1443.17 221 1447.07 218.73L1458.75 211.96L1470.44 205.21L1482.12 198.47L1493.8 191.72L1505.5 184.96L1517.19 178.21L1528.87 171.47L1540.57 164.73C1544.47 162.49 1548.36 160.25 1552.25 158.06C1556.14 155.87 1560.04 153.68 1563.93 151.67C1567.72 149.659 1571.62 147.85 1575.61 146.25C1579.37 144.718 1583.29 143.614 1587.3 142.96C1591.17 142.405 1595.09 142.365 1598.97 142.84C1602.86 143.28 1606.76 144.17 1610.65 144.94C1614.48 145.817 1618.4 146.253 1622.33 146.24C1626.4 146.126 1630.38 145.101 1634 143.24C1638.36 140.893 1642.31 137.853 1645.69 134.24C1649.88 129.806 1653.78 125.106 1657.36 120.17C1661.25 114.99 1665.15 109.52 1669.05 104.43C1672.95 99.3401 1676.83 94.6201 1680.73 90.4301C1684.37 86.5502 1688.27 82.9188 1692.4 79.5602C1696.15 76.5164 1700.05 73.666 1704.09 71.0202C1707.98 68.4502 1711.87 66.0201 1715.77 63.7301C1719.67 61.4401 1723.56 59.1302 1727.45 56.8602L1739.13 50.1102L1750.82 43.3501C1754.71 41.1101 1758.6 38.8502 1762.5 36.6102L1771.94 31.1602"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1193.67 556L1332.67 475.74L1343.23 469.64L1355.16 462.75L1367.1 455.86L1378.83 449.09L1390.5 442.34L1402.23 435.56L1413.9 428.82L1425.59 422.07L1437.27 415.33L1448.95 408.58C1452.85 406.34 1456.75 404.093 1460.63 401.84L1472.32 395.1L1484 388.35C1487.89 386.103 1491.78 383.856 1495.68 381.61L1507.36 374.86L1519.04 368.12L1530.72 361.39C1534.61 359.156 1538.51 356.936 1542.41 354.73C1546.3 352.54 1550.19 350.38 1554.08 348.29C1557.97 346.2 1561.87 344.22 1565.77 342.41C1569.67 340.6 1573.55 338.95 1577.44 337.53C1581.27 336.122 1585.17 334.927 1589.13 333.95C1593.02 332.95 1596.91 332.29 1600.8 331.73C1604.69 331.17 1608.59 330.73 1612.49 330.35C1616.39 329.97 1620.27 329.5 1624.17 328.9C1628.1 328.329 1632 327.548 1635.85 326.56C1639.82 325.487 1643.72 324.185 1647.54 322.66C1651.43 321.12 1655.33 319.35 1659.22 317.41C1663.11 315.47 1667.01 313.41 1670.91 311.14C1674.81 308.87 1678.7 306.55 1682.6 304.04C1686.5 301.53 1690.39 298.83 1694.29 295.91C1698.19 292.99 1702.09 289.82 1705.97 286.35C1709.85 282.88 1713.77 279.09 1717.65 275.14C1721.53 271.19 1725.46 267.03 1729.34 262.86C1733.22 258.69 1737.14 254.42 1741.02 250.41C1744.9 246.4 1748.82 242.54 1752.7 239C1756.58 235.46 1760.49 232.17 1764.38 229.16C1766.9 227.2 1769.42 225.346 1771.94 223.6"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1086 83.34L1090.92 80.5L1102.6 73.76L1114.27 67.02L1125.96 60.27L1137.63 53.56L1149.32 46.81L1161 40.07L1172.68 33.33L1184.37 26.56L1196.06 19.81L1207.74 13.06L1219.43 6.31999L1231.12 -0.440002L1242.8 -7.19L1254.5 -13.93L1266.19 -20.68L1277.85 -27.44L1289.5 -34.17L1301.18 -40.91L1312.86 -47.65L1324.57 -54.44L1336.24 -61.18L1347.92 -67.92L1359.6 -74.66L1371.28 -81.41L1382.97 -88.15C1386.86 -90.3967 1390.75 -92.6433 1394.65 -94.89L1406.33 -101.63C1410.23 -103.86 1414.12 -106.09 1418.01 -108.27C1421.9 -110.45 1425.81 -112.6 1429.7 -114.58C1433.5 -116.549 1437.4 -118.318 1441.38 -119.88C1443.38 -120.64 1445.33 -121.31 1447.29 -121.88C1449.19 -122.429 1451.11 -122.866 1453.06 -123.19C1456.92 -123.816 1460.85 -123.98 1464.75 -123.68C1465.75 -123.6 1466.75 -123.51 1467.75 -123.38C1468.75 -123.25 1469.75 -123.13 1470.68 -122.98C1472.62 -122.7 1474.56 -122.37 1476.5 -122.07C1477.5 -121.93 1478.43 -121.78 1479.41 -121.65C1480.39 -121.52 1481.41 -121.41 1482.36 -121.31C1484.38 -121.112 1486.41 -121.055 1488.44 -121.14C1490.4 -121.235 1492.35 -121.482 1494.27 -121.88C1496.35 -122.319 1498.39 -122.952 1500.36 -123.77C1501.24 -124.14 1502.12 -124.55 1503.01 -125.02C1503.9 -125.49 1504.78 -126.02 1505.67 -126.57C1506.56 -127.12 1507.44 -127.74 1508.32 -128.39C1509.02 -128.9 1509.71 -129.39 1510.4 -130"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1086 121.561L1089 119.861L1100.69 113.111L1112.37 106.371L1124 99.5608L1135.68 92.8208C1139.57 90.5741 1143.47 88.3274 1147.36 86.0808L1159.04 79.3308L1170.72 72.5908L1182.4 65.8508L1194.08 59.1008L1205.76 52.3608L1217.5 45.6508L1229.18 38.9008L1240.88 32.1508L1252.5 25.4108L1264.19 18.6608L1275.88 11.9108L1287.56 5.17078L1299.24 -1.57922L1310.92 -8.31921L1322.6 -15.0692L1334.28 -21.8092L1345.96 -28.5492L1357.64 -35.2992L1369.32 -42.0292L1381 -48.7792L1392.67 -55.5192L1404.36 -62.2692L1416.04 -69.0092C1419.93 -71.2492 1423.82 -73.4826 1427.72 -75.7092C1431.61 -77.9292 1435.51 -80.1292 1439.41 -82.2492C1443.31 -84.3692 1447.2 -86.3792 1451.09 -88.1592C1454.86 -89.9385 1458.77 -91.4035 1462.78 -92.5392C1466.6 -93.5861 1470.54 -94.1505 1474.5 -94.2192C1478.42 -94.2336 1482.33 -93.8989 1486.19 -93.2192C1488.13 -92.8992 1490.06 -92.5292 1492 -92.2192C1493 -92.0492 1493.94 -91.8892 1494.92 -91.7492C1495.9 -91.6092 1496.92 -91.4692 1497.92 -91.3692C1499.81 -91.1558 1501.71 -91.079 1503.61 -91.1392C1505.63 -91.209 1507.64 -91.4905 1509.61 -91.9792C1510.61 -92.2408 1511.59 -92.5546 1512.55 -92.9192C1513.57 -93.3053 1514.58 -93.7493 1515.55 -94.2492C1516.55 -94.7592 1517.55 -95.3292 1518.55 -95.9692C1519.55 -96.6092 1520.55 -97.3192 1521.55 -98.0792C1523.68 -99.7396 1525.71 -101.53 1527.62 -103.439C1529.62 -105.439 1531.55 -107.519 1533.43 -109.689C1535.31 -111.859 1537.04 -114.019 1538.81 -116.289C1540.58 -118.559 1542.28 -120.849 1544 -123.139C1545.72 -125.429 1547.42 -127.729 1549.09 -129.949"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1086 159.749L1087 159.169L1098.68 152.429L1110.37 145.679L1122.05 138.939L1133.73 132.189L1145.41 125.449L1157.09 118.709L1168.78 111.959L1180.45 105.219L1192.14 98.4686L1203.81 91.7286L1215.5 84.9886L1227.18 78.2386C1231.08 75.9919 1234.98 73.7419 1238.87 71.4886L1250.5 64.7486C1254.4 62.5019 1258.3 60.2519 1262.19 57.9986L1273.88 51.2586L1285.6 44.5586L1297.28 37.8086L1308.97 31.0586L1320.65 24.3186L1332.34 17.5586L1344.01 10.8186L1355.7 4.06859L1367.37 -2.67141C1371.27 -4.91141 1375.16 -7.15807 1379.05 -9.41141L1390.74 -16.1514L1402.4 -22.8914L1414.1 -29.6414L1425.77 -36.4414L1437.5 -43.1514C1441.39 -45.3814 1445.29 -47.6114 1449.18 -49.7914C1453.07 -51.9714 1456.96 -54.1014 1460.86 -56.0714C1464.64 -58.0243 1468.53 -59.7637 1472.5 -61.2814C1476.28 -62.6812 1480.19 -63.6865 1484.18 -64.2814C1488.05 -64.8177 1491.98 -64.8848 1495.87 -64.4814C1499.76 -64.1014 1503.65 -63.2814 1507.54 -62.6014C1511.39 -61.8427 1515.31 -61.5073 1519.23 -61.6014C1521.15 -61.6942 1523.06 -61.9722 1524.93 -62.4314C1525.95 -62.678 1526.95 -62.9784 1527.93 -63.3314C1528.95 -63.7078 1529.96 -64.1419 1530.93 -64.6314C1531.93 -65.1214 1532.93 -65.6314 1533.93 -66.2914C1534.42 -66.6014 1534.93 -66.9214 1535.41 -67.2914C1535.89 -67.6614 1536.41 -67.9914 1536.9 -68.3514C1537.9 -69.0914 1538.85 -69.8814 1539.82 -70.7114C1540.79 -71.5414 1541.74 -72.4214 1542.67 -73.3414C1544.77 -75.3414 1546.83 -77.6314 1548.81 -79.9514C1549.81 -81.1014 1550.81 -82.2914 1551.74 -83.4814C1552.67 -84.6714 1553.67 -85.8914 1554.61 -87.1114C1555.55 -88.3314 1556.61 -89.7314 1557.61 -91.0414L1560.61 -95.0414L1563.61 -99.0414C1564.61 -100.351 1565.61 -101.691 1566.61 -102.981C1570.08 -107.511 1573.45 -111.651 1577.18 -115.781C1580.84 -119.869 1584.72 -123.761 1588.79 -127.441C1589.74 -128.291 1590.68 -129.131 1591.63 -129.941"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1086 388.95C1102.06 379.683 1118.12 370.413 1134.19 361.14L1144.75 355.03L1156.68 348.15L1168.62 341.25L1180.35 334.48L1192.04 327.75C1195.93 325.52 1199.83 323.29 1203.73 321.1C1207.63 318.91 1211.51 316.76 1215.4 314.73C1219.29 312.7 1223.19 310.81 1227.08 309.22C1230.86 307.663 1234.77 306.438 1238.76 305.56C1242.6 304.729 1246.53 304.35 1250.46 304.43C1254.37 304.604 1258.27 305.032 1262.13 305.71C1265.99 306.407 1269.89 306.858 1273.81 307.06C1277.77 307.232 1281.73 306.697 1285.5 305.48C1289.75 303.995 1293.7 301.77 1297.18 298.91C1301.45 295.404 1305.36 291.493 1308.87 287.23C1312.76 282.65 1316.66 277.48 1320.55 272.38C1324.44 267.28 1328.33 262.23 1332.23 257.62C1335.9 253.25 1339.79 249.08 1343.91 245.13C1347.61 241.614 1351.51 238.309 1355.59 235.23C1359.49 232.28 1363.38 229.63 1367.28 227.12C1371.18 224.61 1375.06 222.26 1378.95 219.95C1382.84 217.64 1386.74 215.36 1390.64 213.1C1394.54 210.84 1398.42 208.59 1402.31 206.34L1413.99 199.56L1425.67 192.82L1437.35 186.07L1449.04 179.33L1460.72 172.58L1472.41 165.83L1484.1 159.08L1495.79 152.33L1507.5 145.62L1519.18 138.88C1523.09 136.633 1526.99 134.4 1530.87 132.18C1534.77 129.96 1538.66 127.77 1542.55 125.68C1546.44 123.59 1550.34 121.6 1554.23 119.9C1557.99 118.224 1561.9 116.886 1565.9 115.9C1569.72 114.972 1573.65 114.552 1577.58 114.65C1581.51 114.827 1585.42 115.343 1589.27 116.19C1593.12 117.094 1597.01 117.762 1600.94 118.19C1604.89 118.553 1608.87 118.096 1612.63 116.85C1616.92 115.3 1620.88 112.956 1624.3 109.94C1628.55 106.177 1632.45 102.033 1635.95 97.5599C1639.84 92.7599 1643.74 87.4199 1647.64 82.1899C1651.54 76.9599 1655.42 71.8599 1659.32 67.2899C1662.95 62.9987 1666.86 58.9407 1671 55.1399C1674.7 51.7817 1678.6 48.6462 1682.68 45.7499C1686.58 42.9499 1690.47 40.4399 1694.37 38.0299C1698.27 35.6199 1702.15 33.3199 1706.05 31.0299C1709.95 28.7399 1713.84 26.4799 1717.73 24.2299L1729.42 17.4699L1741.15 10.6999L1753.08 3.80992L1765.01 -3.08008L1771.94 -7.08008"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="20"
      fontWeight="800"
      letterSpacing="0em"
    >
      <tspan x="1537.45" y="67">
        CPU
      </tspan>
    </text>
    <text
      fill="url(#paint2_linear_1112_12254)"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="76"
      fontWeight="800"
      letterSpacing="0em"
    >
      <tspan x="1474.48" y="140.6">
        88%
      </tspan>
    </text>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="18"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="1519.2" y="171.8">
        Address:&#10;
      </tspan>
      <tspan x="1514.26" y="194.8">
        0x4553e0
      </tspan>
    </text>
    <rect x="512" y="181" width="904" height="493" rx="12" fill="white" />
    <path
      d="M1312.49 580.573C1312.32 580.573 1312.28 580.494 1312.37 580.377L1313.25 579.317C1313.33 579.2 1313.54 579.121 1313.71 579.121H1328.65C1328.82 579.121 1328.86 579.239 1328.78 579.357L1328.07 580.377C1327.98 580.494 1327.77 580.612 1327.65 580.612L1312.49 580.573Z"
      fill="#00ACD7"
    />
    <path
      d="M1306.17 584.182C1306 584.182 1305.96 584.104 1306.04 583.986L1306.92 582.927C1307 582.809 1307.21 582.73 1307.38 582.73H1326.48C1326.64 582.73 1326.73 582.848 1326.68 582.966L1326.35 583.907C1326.31 584.064 1326.14 584.143 1325.97 584.143L1306.17 584.182Z"
      fill="#00ACD7"
    />
    <path
      d="M1316.3 587.792C1316.13 587.792 1316.09 587.674 1316.17 587.556L1316.76 586.575C1316.84 586.458 1317.01 586.34 1317.18 586.34H1325.55C1325.72 586.34 1325.81 586.458 1325.81 586.614L1325.72 587.556C1325.72 587.713 1325.55 587.831 1325.43 587.831L1316.3 587.792Z"
      fill="#00ACD7"
    />
    <path
      d="M1359.77 579.867C1357.13 580.494 1355.33 580.965 1352.73 581.593C1352.1 581.75 1352.06 581.789 1351.52 581.201C1350.89 580.534 1350.43 580.102 1349.55 579.71C1346.91 578.493 1344.36 578.847 1341.97 580.298C1339.12 582.025 1337.66 584.575 1337.7 587.753C1337.74 590.892 1340.04 593.481 1343.35 593.913C1346.2 594.266 1348.59 593.324 1350.47 591.323C1350.85 590.892 1351.18 590.421 1351.6 589.871H1343.52C1342.64 589.871 1342.43 589.361 1342.72 588.694C1343.27 587.478 1344.27 585.438 1344.86 584.418C1344.98 584.182 1345.28 583.79 1345.91 583.79H1361.15C1361.06 584.849 1361.06 585.909 1360.9 586.968C1360.44 589.793 1359.3 592.382 1357.46 594.658C1354.45 598.385 1350.51 600.7 1345.53 601.328C1341.43 601.838 1337.61 601.092 1334.27 598.738C1331.17 596.541 1329.41 593.638 1328.95 590.028C1328.4 585.752 1329.74 581.907 1332.51 578.533C1335.48 574.884 1339.42 572.569 1344.23 571.745C1348.17 571.078 1351.94 571.51 1355.33 573.668C1357.55 575.041 1359.14 576.924 1360.18 579.2C1360.44 579.553 1360.27 579.749 1359.77 579.867Z"
      fill="#00ACD7"
    />
    <path
      d="M1373.63 601.563C1369.82 601.485 1366.34 600.465 1363.41 598.111C1360.94 596.11 1359.39 593.559 1358.89 590.538C1358.13 586.105 1359.43 582.181 1362.28 578.69C1365.33 574.923 1369.02 572.961 1374 572.137C1378.27 571.431 1382.29 571.824 1385.94 574.138C1389.24 576.257 1391.3 579.121 1391.84 582.888C1392.55 588.184 1390.92 592.5 1387.02 596.188C1384.26 598.817 1380.87 600.465 1376.98 601.21C1375.84 601.406 1374.71 601.445 1373.63 601.563ZM1383.59 585.713C1383.55 585.202 1383.55 584.81 1383.47 584.418C1382.71 580.534 1378.9 578.336 1374.92 579.2C1371.03 580.024 1368.52 582.338 1367.6 586.026C1366.84 589.087 1368.43 592.186 1371.45 593.442C1373.75 594.383 1376.05 594.266 1378.27 593.206C1381.58 591.598 1383.38 589.087 1383.59 585.713Z"
      fill="#00ACD7"
    />
    <rect x="561" y="218" width="1" height="456" fill="#E4E6E7" />
    <text
      fill="#798486"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="528" y="249.938">
        54&#10;
      </tspan>
      <tspan x="528" y="270.938">
        55&#10;
      </tspan>
      <tspan x="528" y="291.938">
        56&#10;
      </tspan>
      <tspan x="528" y="312.938">
        57&#10;
      </tspan>
      <tspan x="528" y="333.938">
        58&#10;
      </tspan>
      <tspan x="528" y="354.938">
        58&#10;
      </tspan>
      <tspan x="528" y="375.938">
        60&#10;
      </tspan>
      <tspan x="528" y="396.938">
        61&#10;
      </tspan>
      <tspan x="528" y="417.938">
        62&#10;
      </tspan>
      <tspan x="528" y="438.938">
        63&#10;
      </tspan>
      <tspan x="528" y="459.938">
        64&#10;
      </tspan>
      <tspan x="528" y="480.938">
        65&#10;
      </tspan>
      <tspan x="528" y="501.938">
        66&#10;
      </tspan>
      <tspan x="528" y="522.938">
        67&#10;
      </tspan>
      <tspan x="528" y="543.938">
        68&#10;
      </tspan>
      <tspan x="528" y="564.938">
        69&#10;
      </tspan>
      <tspan x="528" y="585.938">
        70&#10;
      </tspan>
      <tspan x="528" y="606.938">
        71&#10;
      </tspan>
      <tspan x="528" y="627.938">
        72&#10;
      </tspan>
      <tspan x="528" y="648.938">
        73
      </tspan>
    </text>
    <path
      d="M512 193C512 186.373 517.373 181 524 181H1404C1410.63 181 1416 186.373 1416 193V217H512V193Z"
      fill="white"
    />
    <circle cx="534" cy="199" r="6" fill="#FD0054" />
    <circle cx="554" cy="199" r="6" fill="#FFB31A" />
    <circle cx="574" cy="199" r="6" fill="#00CC21" />
    <rect x="512" y="217" width="904" height="1" fill="#E4E6E7" />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="619.633" y="249.938">
        {' '}
        (g{' '}
      </tspan>
      <tspan x="661.674" y="249.938">
        Graph){' '}
      </tspan>
      <tspan x="813.021" y="249.938">
        (start, end int) (isReachable bool, distance int, err error) {'{'}&#10;
      </tspan>
      <tspan x="586" y="270.938">
        {' '}
        INF{' '}
      </tspan>
      <tspan x="644.857" y="270.938">
        {' '}
        math.
      </tspan>
      <tspan x="720.531" y="270.938">
        (
      </tspan>
      <tspan x="737.348" y="270.938">
        )&#10;
      </tspan>
      <tspan x="586" y="291.938">
        {' '}
        distances{' '}
      </tspan>
      <tspan x="695.307" y="291.938">
        {' '}
      </tspan>
      <tspan x="737.348" y="291.938">
        ([]float64, g.
      </tspan>
      <tspan x="922.328" y="291.938">
        )&#10;
      </tspan>
      <tspan x="586" y="312.938" />
      <tspan x="586" y="354.938">
        {' '}
      </tspan>
      <tspan x="619.633" y="354.938">
        {' '}
        i{' '}
      </tspan>
      <tspan x="661.674" y="354.938">
        {' '}
        0; i &#60; g.
      </tspan>
      <tspan x="813.021" y="354.938">
        ; i
      </tspan>
      <tspan x="855.062" y="354.938">
        {' '}
        {'{'}&#10;
      </tspan>
      <tspan x="586" y="375.938">
        {' '}
        distances[i]{' '}
      </tspan>
      <tspan x="720.531" y="375.938">
        {' '}
        INF&#10;
      </tspan>
      <tspan x="586" y="396.938">
        {' '}
        {'}'}&#10;
      </tspan>
      <tspan x="586" y="417.938">
        {' '}
        distances[start]{' '}
      </tspan>
      <tspan x="586" y="438.938" />
      <tspan x="586" y="459.938">
        {' '}
      </tspan>
      <tspan x="586" y="480.938">
        {' '}
      </tspan>
      <tspan x="619.633" y="480.938">
        {' '}
        n{' '}
      </tspan>
      <tspan x="678.49" y="480.938">
        ; n{' '}
      </tspan>
      <tspan x="720.531" y="480.938">
        {' '}
        g.
      </tspan>
      <tspan x="813.021" y="480.938">
        ; n
      </tspan>
      <tspan x="855.062" y="480.938">
        {' '}
        {'{'}&#10;
      </tspan>
      <tspan x="586" y="501.938" />
      <tspan x="586" y="522.938">
        {' '}
      </tspan>
      <tspan x="586" y="543.938">
        {' '}
      </tspan>
      <tspan x="628.041" y="543.938">
        {' '}
        u, adjacents{' '}
      </tspan>
      <tspan x="762.572" y="543.938">
        {' '}
      </tspan>
      <tspan x="813.021" y="543.938">
        {' '}
        g.
      </tspan>
      <tspan x="880.287" y="543.938">
        {' '}
        {'{'}&#10;
      </tspan>
      <tspan x="586" y="564.938">
        {' '}
      </tspan>
      <tspan x="636.449" y="564.938">
        {' '}
        v, weightUV{' '}
      </tspan>
      <tspan x="762.572" y="564.938">
        {' '}
      </tspan>
      <tspan x="813.021" y="564.938">
        {' '}
        adjacents {'{'}&#10;
      </tspan>
      <tspan x="586" y="585.938" />
      <tspan x="586" y="606.938">
        {' '}
      </tspan>
      <tspan x="586" y="627.938">
        {' '}
      </tspan>
      <tspan x="636.449" y="627.938">
        {' '}
        newDistance{' '}
      </tspan>
      <tspan x="762.572" y="627.938">
        {' '}
        distances[u]{' '}
      </tspan>
      <tspan x="888.695" y="627.938">
        {' '}
      </tspan>
      <tspan x="955.961" y="627.938">
        (weightUV); distances[v]{' '}
      </tspan>
      <tspan x="1174.57" y="627.938">
        {' '}
        newDistance {'{'}&#10;
      </tspan>
      <tspan x="586" y="648.938">
        {' '}
        distances[v]{' '}
      </tspan>
      <tspan x="745.756" y="648.938">
        {' '}
        newDistance
      </tspan>
    </text>
    <text
      fill="#798486"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="586" y="333.938">
        {' '}
        // Set all vertices to unreachable, initialize source&#10;
      </tspan>
      <tspan x="594.408" y="459.938">
        // Making iterations equal to #vertices&#10;
      </tspan>
      <tspan x="602.816" y="522.938">
        // Looping over all edges&#10;
      </tspan>
      <tspan x="619.633" y="606.938">
        // If new shorter distance is found, update distance value (relaxation step)&#10;
      </tspan>
    </text>
    <text
      fill="#FD0054"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="586" y="249.938">
        func
      </tspan>
      <tspan x="594.408" y="354.938">
        for
      </tspan>
      <tspan x="594.408" y="480.938">
        for
      </tspan>
      <tspan x="602.816" y="543.938">
        for
      </tspan>
      <tspan x="770.98" y="543.938">
        range
      </tspan>
      <tspan x="611.225" y="564.938">
        for
      </tspan>
      <tspan x="770.98" y="564.938">
        range
      </tspan>
      <tspan x="619.633" y="627.938">
        if
      </tspan>
    </text>
    <text
      fill="#001A9B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="653.266" y="249.938">
        *
      </tspan>
      <tspan x="628.041" y="270.938">
        :=
      </tspan>
      <tspan x="728.939" y="270.938">
        1
      </tspan>
      <tspan x="678.49" y="291.938">
        :=
      </tspan>
      <tspan x="855.062" y="291.938">
        vertices
      </tspan>
      <tspan x="644.857" y="354.938">
        :=
      </tspan>
      <tspan x="745.756" y="354.938">
        vertices
      </tspan>
      <tspan x="838.246" y="354.938">
        ++
      </tspan>
      <tspan x="712.123" y="375.938">
        =
      </tspan>
      <tspan x="737.348" y="417.938">
        = 0&#10;
      </tspan>
      <tspan x="644.857" y="480.938">
        := 0
      </tspan>
      <tspan x="712.123" y="480.938">
        &#60;
      </tspan>
      <tspan x="745.756" y="480.938">
        vertices
      </tspan>
      <tspan x="838.246" y="480.938">
        ++
      </tspan>
      <tspan x="745.756" y="543.938">
        :=
      </tspan>
      <tspan x="838.246" y="543.938">
        edges
      </tspan>
      <tspan x="745.756" y="564.938">
        :=
      </tspan>
      <tspan x="745.756" y="627.938">
        :=
      </tspan>
      <tspan x="880.287" y="627.938">
        +
      </tspan>
      <tspan x="1166.17" y="627.938">
        &#62;
      </tspan>
      <tspan x="737.348" y="648.938">
        =
      </tspan>
    </text>
    <text
      fill="#8152E0"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="720.531" y="249.938">
        BellmanFord
      </tspan>
      <tspan x="695.307" y="270.938">
        Inf
      </tspan>
      <tspan x="703.715" y="291.938">
        make
      </tspan>
      <tspan x="897.104" y="627.938">
        float64
      </tspan>
    </text>
    <g filter="url(#filter0_ddd_1112_12254)">
      <rect x="496" y="181" width="936" height="493" rx="12" fill="white" />
    </g>
    <rect opacity="0.1" x="496" y="277" width="936" height="24" fill="#FD0054" />
    <path
      d="M1318.32 630.296C1318.13 630.296 1318.09 630.207 1318.18 630.074L1319.17 628.878C1319.27 628.745 1319.5 628.656 1319.69 628.656H1336.55C1336.74 628.656 1336.79 628.789 1336.69 628.922L1335.89 630.074C1335.8 630.207 1335.56 630.34 1335.42 630.34L1318.32 630.296Z"
      fill="#00ACD7"
    />
    <path
      d="M1311.19 634.374C1311 634.374 1310.95 634.285 1311.05 634.152L1312.04 632.956C1312.13 632.823 1312.37 632.734 1312.56 632.734H1334.09C1334.28 632.734 1334.38 632.867 1334.33 633L1333.95 634.064C1333.9 634.241 1333.72 634.329 1333.53 634.329L1311.19 634.374Z"
      fill="#00ACD7"
    />
    <path
      d="M1322.62 638.448C1322.43 638.448 1322.39 638.315 1322.48 638.182L1323.14 637.074C1323.24 636.942 1323.43 636.809 1323.61 636.809H1333.06C1333.25 636.809 1333.34 636.942 1333.34 637.119L1333.25 638.182C1333.25 638.359 1333.06 638.492 1332.92 638.492L1322.62 638.448Z"
      fill="#00ACD7"
    />
    <path
      d="M1371.64 629.497C1368.67 630.206 1366.64 630.738 1363.71 631.447C1363 631.624 1362.95 631.669 1362.34 631.004C1361.63 630.251 1361.11 629.763 1360.12 629.32C1357.14 627.947 1354.26 628.345 1351.57 629.985C1348.36 631.934 1346.71 634.815 1346.75 638.404C1346.8 641.948 1349.4 644.873 1353.13 645.36C1356.34 645.759 1359.03 644.696 1361.16 642.436C1361.58 641.948 1361.96 641.417 1362.43 640.796H1353.32C1352.33 640.796 1352.09 640.22 1352.42 639.467C1353.04 638.093 1354.17 635.789 1354.83 634.637C1354.97 634.371 1355.3 633.928 1356.01 633.928H1373.2C1373.11 635.125 1373.11 636.321 1372.92 637.517C1372.4 640.708 1371.12 643.632 1369.05 646.202C1365.65 650.411 1361.21 653.026 1355.59 653.735C1350.96 654.311 1346.66 653.469 1342.88 650.81C1339.39 648.329 1337.4 645.05 1336.88 640.974C1336.27 636.144 1337.78 631.802 1340.9 627.991C1344.25 623.87 1348.69 621.256 1354.12 620.325C1358.56 619.572 1362.81 620.06 1366.64 622.497C1369.14 624.047 1370.93 626.174 1372.12 628.744C1372.4 629.143 1372.21 629.364 1371.64 629.497Z"
      fill="#00ACD7"
    />
    <path
      d="M1387.27 654C1382.97 653.912 1379.05 652.76 1375.75 650.101C1372.96 647.841 1371.21 644.961 1370.65 641.549C1369.8 636.542 1371.26 632.112 1374.47 628.168C1377.92 623.914 1382.08 621.699 1387.7 620.768C1392.51 619.971 1397.05 620.414 1401.16 623.028C1404.89 625.421 1407.2 628.655 1407.82 632.909C1408.62 638.891 1406.78 643.765 1402.38 647.93C1399.27 650.899 1395.44 652.76 1391.05 653.602C1389.77 653.823 1388.5 653.867 1387.27 654ZM1398.51 636.099C1398.46 635.523 1398.46 635.08 1398.37 634.637C1397.52 630.251 1393.22 627.769 1388.74 628.744C1384.34 629.675 1381.51 632.289 1380.47 636.454C1379.62 639.91 1381.42 643.41 1384.82 644.828C1387.41 645.892 1390.01 645.759 1392.51 644.562C1396.24 642.746 1398.28 639.91 1398.51 636.099Z"
      fill="#00ACD7"
    />
    <rect opacity="0.1" x="545" y="218" width="1" height="456" fill="#181A1B" />
    <text
      opacity="0.6"
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="512.184" y="249.938">
        54&#10;
      </tspan>
      <tspan x="512.184" y="270.938">
        55&#10;
      </tspan>
      <tspan x="512.184" y="291.938">
        56&#10;
      </tspan>
      <tspan x="512.184" y="312.938">
        57&#10;
      </tspan>
      <tspan x="512.184" y="333.938">
        58&#10;
      </tspan>
      <tspan x="512.184" y="354.938">
        58&#10;
      </tspan>
      <tspan x="512.184" y="375.938">
        60&#10;
      </tspan>
      <tspan x="512.184" y="396.938">
        61&#10;
      </tspan>
      <tspan x="512.184" y="417.938">
        62&#10;
      </tspan>
      <tspan x="512.184" y="438.938">
        63&#10;
      </tspan>
      <tspan x="512.184" y="459.938">
        64&#10;
      </tspan>
      <tspan x="512.184" y="480.938">
        65&#10;
      </tspan>
      <tspan x="512.184" y="501.938">
        66&#10;
      </tspan>
      <tspan x="512.184" y="522.938">
        67&#10;
      </tspan>
      <tspan x="512.184" y="543.938">
        68&#10;
      </tspan>
      <tspan x="512.184" y="564.938">
        69&#10;
      </tspan>
      <tspan x="512.184" y="585.938">
        70&#10;
      </tspan>
      <tspan x="512.184" y="606.938">
        71&#10;
      </tspan>
      <tspan x="512.184" y="627.938">
        72&#10;
      </tspan>
      <tspan x="512.184" y="648.938">
        73
      </tspan>
    </text>
    <path
      d="M496 193C496 186.373 501.373 181 508 181H1420C1426.63 181 1432 186.373 1432 193V217H496V193Z"
      fill="white"
    />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="14"
      fontWeight="600"
      letterSpacing="0em"
    >
      <tspan x="952.131" y="203.9">
        GO
      </tspan>
    </text>
    <circle cx="518" cy="199" r="6" fill="#FD0054" />
    <circle cx="538" cy="199" r="6" fill="#FFB31A" />
    <circle cx="558" cy="199" r="6" fill="#00CC21" />
    <rect opacity="0.1" x="496" y="217" width="936" height="1" fill="#181A1B" />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="603.633" y="249.938">
        {' '}
        (g{' '}
      </tspan>
      <tspan x="645.674" y="249.938">
        Graph){' '}
      </tspan>
      <tspan x="797.021" y="249.938">
        (start, end int) (isReachable bool, distance int, err error) {'{'}&#10;
      </tspan>
      <tspan x="570" y="270.938">
        {' '}
        INF{' '}
      </tspan>
      <tspan x="628.857" y="270.938">
        {' '}
        math.
      </tspan>
      <tspan x="704.531" y="270.938">
        (
      </tspan>
      <tspan x="721.348" y="270.938">
        )&#10;
      </tspan>
      <tspan x="570" y="291.938">
        {' '}
        distances{' '}
      </tspan>
      <tspan x="679.307" y="291.938">
        {' '}
      </tspan>
      <tspan x="721.348" y="291.938">
        ([]float64, g.
      </tspan>
      <tspan x="906.328" y="291.938">
        )&#10;
      </tspan>
      <tspan x="570" y="312.938" />
      <tspan x="570" y="354.938">
        {' '}
      </tspan>
      <tspan x="603.633" y="354.938">
        {' '}
        i{' '}
      </tspan>
      <tspan x="645.674" y="354.938">
        {' '}
        0; i &#60; g.
      </tspan>
      <tspan x="797.021" y="354.938">
        ; i
      </tspan>
      <tspan x="839.062" y="354.938">
        {' '}
        {'{'}&#10;
      </tspan>
      <tspan x="570" y="375.938">
        {'  '}
        distances[i]{' '}
      </tspan>
      <tspan x="704.531" y="375.938">
        {' '}
        INF&#10;
      </tspan>
      <tspan x="570" y="396.938">
        {' '}
        {'}'}&#10;
      </tspan>
      <tspan x="570" y="417.938">
        {' '}
        distances[start]{' '}
      </tspan>
      <tspan x="570" y="438.938" />
      <tspan x="570" y="459.938">
        {' '}
      </tspan>
      <tspan x="570" y="480.938">
        {' '}
      </tspan>
      <tspan x="603.633" y="480.938">
        {' '}
        n{' '}
      </tspan>
      <tspan x="662.49" y="480.938">
        ; n{' '}
      </tspan>
      <tspan x="704.531" y="480.938">
        {' '}
        g.
      </tspan>
      <tspan x="797.021" y="480.938">
        ; n
      </tspan>
      <tspan x="839.062" y="480.938">
        {' '}
        {'{'}&#10;
      </tspan>
      <tspan x="570" y="501.938" />
      <tspan x="570" y="522.938">
        {' '}
      </tspan>
      <tspan x="570" y="543.938">
        {' '}
      </tspan>
      <tspan x="612.041" y="543.938">
        {' '}
        u, adjacents{' '}
      </tspan>
      <tspan x="746.572" y="543.938">
        {' '}
      </tspan>
      <tspan x="797.021" y="543.938">
        {' '}
        g.
      </tspan>
      <tspan x="864.287" y="543.938">
        {' '}
        {'{'}&#10;
      </tspan>
      <tspan x="570" y="564.938">
        {' '}
      </tspan>
      <tspan x="620.449" y="564.938">
        {' '}
        v, weightUV{' '}
      </tspan>
      <tspan x="746.572" y="564.938">
        {' '}
      </tspan>
      <tspan x="797.021" y="564.938">
        {' '}
        adjacents {'{'}&#10;
      </tspan>
      <tspan x="570" y="585.938" />
      <tspan x="570" y="606.938">
        {' '}
      </tspan>
      <tspan x="570" y="627.938">
        {' '}
      </tspan>
      <tspan x="620.449" y="627.938">
        {' '}
        newDistance{' '}
      </tspan>
      <tspan x="746.572" y="627.938">
        {' '}
        distances[u]{' '}
      </tspan>
      <tspan x="872.695" y="627.938">
        {' '}
      </tspan>
      <tspan x="939.961" y="627.938">
        (weightUV); distances[v]{' '}
      </tspan>
      <tspan x="1158.57" y="627.938">
        {' '}
        newDistance {'{'}&#10;
      </tspan>
      <tspan x="570" y="648.938">
        {'     '}
        distances[v]{' '}
      </tspan>
      <tspan x="729.756" y="648.938">
        {' '}
        newDistance
      </tspan>
    </text>
    <text
      fill="#798486"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="570" y="333.938">
        {' '}
        // Set all vertices to unreachable, initialize source&#10;
      </tspan>
      <tspan x="578.408" y="459.938">
        // Making iterations equal to #vertices&#10;
      </tspan>
      <tspan x="586.816" y="522.938">
        // Looping over all edges&#10;
      </tspan>
      <tspan x="603.633" y="606.938">
        // If new shorter distance is found, update distance value (relaxation step)&#10;
      </tspan>
    </text>
    <text
      fill="#FD0054"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="570" y="249.938">
        func
      </tspan>
      <tspan x="578.408" y="354.938">
        for
      </tspan>
      <tspan x="578.408" y="480.938">
        for
      </tspan>
      <tspan x="586.816" y="543.938">
        for
      </tspan>
      <tspan x="754.98" y="543.938">
        range
      </tspan>
      <tspan x="595.225" y="564.938">
        for
      </tspan>
      <tspan x="754.98" y="564.938">
        range
      </tspan>
      <tspan x="603.633" y="627.938">
        if
      </tspan>
    </text>
    <text
      fill="#001A9B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="637.266" y="249.938">
        *
      </tspan>
      <tspan x="612.041" y="270.938">
        :=
      </tspan>
      <tspan x="712.939" y="270.938">
        1
      </tspan>
      <tspan x="662.49" y="291.938">
        :=
      </tspan>
      <tspan x="839.062" y="291.938">
        vertices
      </tspan>
      <tspan x="628.857" y="354.938">
        :=
      </tspan>
      <tspan x="729.756" y="354.938">
        vertices
      </tspan>
      <tspan x="822.246" y="354.938">
        ++
      </tspan>
      <tspan x="696.123" y="375.938">
        =
      </tspan>
      <tspan x="721.348" y="417.938">
        = 0&#10;
      </tspan>
      <tspan x="628.857" y="480.938">
        := 0
      </tspan>
      <tspan x="696.123" y="480.938">
        &#60;
      </tspan>
      <tspan x="729.756" y="480.938">
        vertices
      </tspan>
      <tspan x="822.246" y="480.938">
        ++
      </tspan>
      <tspan x="729.756" y="543.938">
        :=
      </tspan>
      <tspan x="822.246" y="543.938">
        edges
      </tspan>
      <tspan x="729.756" y="564.938">
        :=
      </tspan>
      <tspan x="729.756" y="627.938">
        :=
      </tspan>
      <tspan x="864.287" y="627.938">
        +
      </tspan>
      <tspan x="1150.17" y="627.938">
        &#62;
      </tspan>
      <tspan x="721.348" y="648.938">
        =
      </tspan>
    </text>
    <text
      fill="#8152E0"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="704.531" y="249.938">
        BellmanFord
      </tspan>
      <tspan x="679.307" y="270.938">
        Inf
      </tspan>
      <tspan x="687.715" y="291.938">
        make
      </tspan>
      <tspan x="881.104" y="627.938">
        float64
      </tspan>
    </text>
    <path
      d="M1432 289L1557.1 289L1557.1 256M1557.1 256L1547.48 267.625M1557.1 256L1566.73 267.625"
      stroke="#181A1B"
      strokeWidth="2"
    />
    <defs>
      <filter
        id="filter0_ddd_1112_12254"
        x="456"
        y="161"
        width="1016"
        height="573"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1112_12254" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1112_12254"
          result="effect2_dropShadow_1112_12254"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="20" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1112_12254"
          result="effect3_dropShadow_1112_12254"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1112_12254"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1112_12254"
        x1="1682"
        y1="-4.7052e-05"
        x2="1434"
        y2="248"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.253937" stopColor="#57F906" />
        <stop offset="0.732284" stopColor="#00CCC0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1112_12254"
        x1="1662"
        y1="20"
        x2="1454"
        y2="228"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.253937" stopColor="#57F906" />
        <stop offset="0.732284" stopColor="#00CCC0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1112_12254"
        x1="1643"
        y1="76"
        x2="1475.83"
        y2="155.831"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.123543" stopColor="#57F906" />
        <stop offset="0.703356" stopColor="#00CCC0" />
      </linearGradient>
    </defs>
  </svg>
);

Go.propTypes = {
  className: PropTypes.string,
};

Go.defaultProps = {
  className: null,
};

export default Go;
